<script>
import { mapGetters } from 'vuex'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  mixins: [MixPanel],
  data() {
    return {
      phaseOneShow: false,
      faqs: [],
      search: null,
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      isNewSubmodule: 'identity/isNewSubmodule',
    }),
    listFaq() {
      let search = this.search
      let items = []
      this.faqs.forEach(function (item) {
        let faq = item.faq
        if (search) {
          faq = item.faq.filter((data) => data.title.toLowerCase().includes(search.toLowerCase()))
        }

        items.push({
          ...item,
          faq: faq,
        })
      })

      return items
    },
    totalFaq() {
      let total = 0
      this.listFaq.forEach(function (item) {
        total += item.faq.length
      })

      return total
    },
  },
  watch: {
    '$i18n.locale': function () {
      this.faqs = []
      this.grantAccess()
    },
  },
  created() {
    this.grantAccess()
    this.setSubmodule()
  },
  methods: {
    focusSearch() {
      this.$refs.searchInput.focus()
    },
    grantAccess() {
      const faqs = [
        {
          key: 'fleet',
          category: this.$t('help.list.fleet.label'),
          faq: [
            {
              title: this.$t('help.list.fleet.title1'),
              content: this.$t('help.list.fleet.content1'),
            },
            {
              title: this.$t('help.list.fleet.title2'),
              content: this.$t('help.list.fleet.content2'),
            },
            {
              title: this.$t('help.list.fleet.title3'),
              content: this.$t('help.list.fleet.content3'),
            },
            {
              title: this.$t('help.list.fleet.title4'),
              content: this.$t('help.list.fleet.content4'),
            },
          ],
        },
        {
          key: 'liveview',
          category: this.$t('help.list.liveview.label'),
          faq: [
            {
              title: this.$t('help.list.liveview.title1'),
              content: this.$t('help.list.liveview.content1'),
            },
            {
              title: this.$t('help.list.liveview.title2'),
              content: this.$t('help.list.liveview.content2'),
            },
            {
              title: this.$t('help.list.liveview.title3'),
              content: this.$t('help.list.liveview.content3'),
            },
            {
              title: this.$t('help.list.liveview.title4'),
              content: this.$t('help.list.liveview.content4'),
            },
          ],
        },
        {
          key: 'notification',
          category: this.$t('help.list.notification.label'),
          faq: [
            {
              title: this.$t('help.list.notification.title1'),
              content: this.$t('help.list.notification.content1'),
            },
          ],
        },
        {
          key: 'temporarytrack',
          category: this.$t('help.list.temporarytrack.label'),
          faq: [
            {
              title: this.$t('help.list.temporarytrack.title1'),
              content: this.$t('help.list.temporarytrack.content1'),
            },
          ],
        },
        {
          key: 'videotrack',
          category: this.$t('help.list.videotrack.label'),
          faq: [
            {
              title: this.$t('help.list.videotrack.title1'),
              content: this.$t('help.list.videotrack.content1'),
            },
            {
              title: this.$t('help.list.videotrack.title2'),
              content: this.$t('help.list.videotrack.content2'),
            },
          ],
        },
        {
          key: 'license',
          category: this.$t('help.list.license.label'),
          faq: [
            {
              title: this.$t('help.list.license.title1'),
              content: this.$t('help.list.license.content1'),
            },
            {
              title: this.$t('help.list.license.title2'),
              content: this.$t('help.list.license.content2'),
            },
          ],
        },
        {
          key: 'report',
          category: this.$t('help.list.report.label'),
          faq: [
            {
              title: this.$t('help.list.report.title1'),
              content: this.$t('help.list.report.content1'),
            },
          ],
        },
        {
          key: 'employee',
          category: this.$t('help.list.employee.label'),
          faq: [
            {
              title: this.$t('help.list.employee.title1'),
              content: this.$t('help.list.employee.content1'),
            },
          ],
        },
        {
          key: 'user',
          category: this.$t('help.list.user.label'),
          faq: [
            {
              title: this.$t('help.list.user.title1'),
              content: this.$t('help.list.user.content1'),
            },
            {
              title: this.$t('help.list.user.title2'),
              content: this.$t('help.list.user.content2'),
            },
          ],
        },
        {
          key: 'vgroup',
          category: this.$t('help.list.vgroup.label'),
          faq: [
            {
              title: this.$t('help.list.vgroup.title1'),
              content: this.$t('help.list.vgroup.content1'),
            },
          ],
        },
      ]
      const mapKeyWithScopeAccess = {
        fleet: 'help_kendaraan:read',
        liveview: 'help_default:read',
        notification: 'help_notifikasi:read',
        temporarytrack: 'help_pelacakansementara:read',
        videotrack: 'help_pelacakanvideo:read',
        license: 'help_lisensi:read',
        report: 'help_laporan:read',
        employee: 'help_karyawan:read',
        user: 'help_pengguna:read',
        vgroup: 'help_grupkendaraan:read',
      }

      for (const iterator of faqs) {
        if (this.hasAccess(mapKeyWithScopeAccess[iterator.key])) {
          this.faqs.push(iterator)
        }
      }
    },
    mixpanelFAQ() {
      this.track('View Pertanyaan Yang Sering Ditanyakan')
    },
    setSubmodule() {
      const mapIdWithSubmodule = {
        fleet: 'f13a-help-kendaraan',
        liveview: 'f3a-help-liveview',
        notification: 'f4a-help-notifikasi',
        temporarytrack: 'f11a-help-pelacakansementara',
        videotrack: 'f7a-help-pelacakanvideo',
        license: 'f9a-help-lisensi',
        report: 'f10a-help-laporan',
        employee: 'f14a-help-karyawan',
        user: 'f15a-help-pengguna',
        vgroup: 'f16a-help-grupkendaraan',
      }

      for (const iterator of this.faqs) {
        const idx = this.faqs.findIndex((e) => e.key === iterator.key)
        const isNewSubmodule = this.isNewSubmodule(mapIdWithSubmodule[iterator.key])
        this.faqs[idx] = { ...this.faqs[idx], isNewSubmodule }
      }
    },
  },
}
</script>

<template>
  <b-tab class="border-0" @click="mixpanelFAQ">
    <template v-slot:title>
      <span class="d-sm-inline-block">{{ $t('help.faq') }}</span>
    </template>

    <div class="mc-help">
      <div class="clearfix pb-3 border-1 border-bottom">
        <h4 class="float-start mc-help__title">
          <strong>{{ $t('help.faq') }}</strong>
        </h4>
        <div class="float-end">
          <label
            class="d-inline-flex align-items-center mc-table-view__search mb-0"
            @click="focusSearch"
          >
            <i class="mc-fa fas fa-search"></i>
            <b-form-input
              type="search"
              :placeholder="$t('global.search') + '...'"
              class="form-control ms-2"
              v-model="search"
              ref="searchInput"
            ></b-form-input>
          </label>
        </div>
      </div>

      <b-tabs content-class="p-3 text-muted" class="mc-help-menu clearfix">
        <b-tab active>
          <template v-slot:title>
            <span class="mc-help__sidebar-link">{{ $t('help.all') }}</span>
          </template>
          <div class="mc-help__content-item">
            <div class="mc-help__content-item-faq" v-for="faq in listFaq" :key="faq.key">
              <p class="mb-1" v-if="faq.faq.length > 0">{{ faq.category }}</p>
              <div class="accordion" v-if="faq.faq.length > 0">
                <div
                  class="mc-help__content-item-faq-list-item"
                  v-for="(question, index) in faq.faq"
                  :key="index"
                >
                  <strong
                    header-tag="header"
                    role="tab"
                    class="d-block mc-help__content-item-faq-list-title"
                    v-b-toggle="faq.key + '-' + index"
                    ><span
                      >{{ question.title }} <i class="mc-fa icon-outline_arrow-ios-down"></i></span
                  ></strong>
                  <b-collapse :id="faq.key + '-' + index" accordion="my-accordion" role="tabpanel">
                    <div
                      class="mc-help__content-item-faq-list-text"
                      v-html="question.content"
                    ></div>
                  </b-collapse>
                </div>
              </div>
            </div>
            <div class="mc-help__content-item-faq" v-if="totalFaq == 0">
              <div class="p-3 d-flex justify-content-center align-items-center flex-column">
                <img src="@/assets/images/warning-icon.png" />
                <h4>{{ $t('help.searchNotFound') }}</h4>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab v-for="faq in listFaq" :key="faq.key">
          <template v-slot:title>
            <span class="mc-help__sidebar-link">{{ faq.category }}</span>
            <span
              v-if="faq.isNewSubmodule"
              class="badge float-end rounded-pill text-end mc-badge__submodule__help"
              >{{ $t('global.new') }}
            </span>
          </template>
          <div class="mc-help__content-item" v-if="faq.faq.length > 0">
            <div class="mc-help__content-item-faq">
              <p class="mb-1">{{ faq.category }}</p>
              <div class="accordion">
                <div
                  class="mc-help__content-item-faq-list-item"
                  v-for="(question, index) in faq.faq"
                  :key="index"
                >
                  <strong
                    header-tag="header"
                    role="tab"
                    class="d-block mc-help__content-item-faq-list-title"
                    v-b-toggle="faq.key + '-special-' + index"
                    ><span
                      >{{ question.title }} <i class="mc-fa icon-outline_arrow-ios-down"></i></span
                  ></strong>
                  <b-collapse
                    :id="faq.key + '-special-' + index"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <div
                      class="mc-help__content-item-faq-list-text"
                      v-html="question.content"
                    ></div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
          <div class="mc-help__content-item-faq" v-else>
            <div class="p-3 d-flex justify-content-center align-items-center flex-column">
              <img src="@/assets/images/warning-icon.png" />
              <h4>{{ $t('help.searchNotFound') }}</h4>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </b-tab>
</template>
